import { HousingTypeNO, HousingTypeSE } from 'src/api/zrm';

type HousingType = HousingTypeSE | HousingTypeNO;

const HousingTypeValues = [...Object.values(HousingTypeSE),
  ...Object.values(HousingTypeNO)].filter((value, index, self) => self.indexOf(value) === index); // remove duplicates

export default HousingType;
export { HousingTypeValues };
